// api/agingReport.api.ts

import apiHandler from "../../../../api/core/apiHandler";

const agingReportApi = apiHandler("receivables/aging");

export default agingReportApi;